import { Modal, useTheme } from "@mui/material";
import React from "react";
import EditablePage from "./EditablePage";
import NormalPage from "./NormalPage";
import { useWeb3Auth } from "../../hooks/useWeb3Auth";
import "./index.css";
const ProfileModal = ({
  address,
  uuid,
  setProfileModalVisible,
  callback,
}: {
  address: string;
  uuid?: string;
  setProfileModalVisible: (value: React.SetStateAction<boolean>) => void;
  callback?: any;
}) => {
  const { address: userAddress, isProticoAuthenticated } = useWeb3Auth();
  const isEditable =
    address === userAddress && userAddress.length > 0 && isProticoAuthenticated;

  return (
    <Modal
      disableAutoFocus
      open={true}
      onClose={() => {
        setProfileModalVisible(false);
      }}
      style={{
        background: "#111111dd",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div className="profileModal-container">
        {isEditable ? (
          <EditablePage />
        ) : (
          <NormalPage address={address} uuid={uuid} callback={callback} />
        )}
      </div>
    </Modal>
  );
};

export default ProfileModal;
